export { default } from './IconButton';


//////////////////
// WEBPACK FOOTER
// ./node_modules/@material-ui/core/esm/IconButton/index.js
// module id = 61
// module chunks = 0